import { util } from '@glu/core';

const LEFT_FIRST = -1;
const RIGHT_FIRST = 1;
const EQUAL = 0;

const ascendingCaseInsensitiveComparator = (a, b) => {
  if (typeof a === 'string' && typeof b === 'string') {
    a = a.toUpperCase();
    b = b.toUpperCase();
  }

  if (a < b) {
    return LEFT_FIRST;
  }

  if (a > b) {
    return RIGHT_FIRST;
  }

  if (a === null) {
    a = undefined;
  }

  if (b === null) {
    b = undefined;
  }

  if (a === undefined && b !== undefined) {
    return LEFT_FIRST;
  }

  if (a !== undefined && b === undefined) {
    return RIGHT_FIRST;
  }

  return EQUAL;
};

const arrayInsensitiveComparator = (a, b, array) => {
  const aIndex = util.indexOf(array, a);
  const bIndex = util.indexOf(array, b);

  return ascendingCaseInsensitiveComparator(aIndex, bIndex);
};

export default {

  ascendingByField(field) {
    return (A, B) => {
      const a = A.get(field);
      const b = B.get(field);
      const primarySort = ascendingCaseInsensitiveComparator(a, b);

      if (primarySort !== EQUAL) {
        return primarySort;
      }

      if (A.gluStableSortIndex !== undefined && B.gluStableSortIndex !== undefined) {
        return A.gluStableSortIndex < B.gluStableSortIndex ? LEFT_FIRST : RIGHT_FIRST;
      }

      return EQUAL;
    };
  },

  descendingByField(field) {
    return (A, B) => {
      const a = A.get(field);
      const b = B.get(field);
      const primarySort = ascendingCaseInsensitiveComparator(a, b) * -1;

      if (primarySort !== EQUAL) {
        return primarySort;
      }

      if (A.gluStableSortIndex !== undefined && B.gluStableSortIndex !== undefined) {
        return A.gluStableSortIndex < B.gluStableSortIndex ? LEFT_FIRST : RIGHT_FIRST;
      }

      return EQUAL;
    };
  },

  multiColumnComparator(fieldCollection) {
    return (A, B) => {
      const sortForField = item => {
        let a = A.get(fieldCollection.models[item].get('field'));
        let b = B.get(fieldCollection.models[item].get('field'));
        const sortingOrder = fieldCollection.models[item].get('multiColumnSort') ? fieldCollection.models[item].get('multiColumnSort') : 'asc';
        let primarySort;

        if (util.isArray(sortingOrder)) {
          primarySort = arrayInsensitiveComparator(a, b, sortingOrder);
        } else if (sortingOrder === 'asc') {
          a = a || Infinity;
          b = b || Infinity;
          primarySort = ascendingCaseInsensitiveComparator(a, b);
        } else if (sortingOrder === 'desc') {
          a = a || -Infinity;
          b = b || -Infinity;
          primarySort = ascendingCaseInsensitiveComparator(a, b) * -1;
        } else if (sortingOrder === 'ascIncludeUndefined') {
          if (util.isUndefined(a)) {
            a = Infinity;
          }
          if (util.isUndefined(b)) {
            b = Infinity;
          }
          primarySort = ascendingCaseInsensitiveComparator(a, b);
        }

        if ((!primarySort) && (item < fieldCollection.length - 1)) {
          return sortForField(item + 1);
        }

        return primarySort;
      };

      return sortForField(0);
    };
  }
};
